import React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { formatCurrency, formatVAT } from '../../lib/currency';
import { ButtonPill } from '../button-pill';
import { styles } from './styles';
import { ORDER_STATE } from '../../modules/checkout/model';

interface CheckoutActionsProps {
  className?: string;
  showVat?: boolean;
  orderReady?: boolean;
  eula: boolean;
  rightsholders: boolean;
  handleCheckout: (event: any, ref?: any) => void;
}

@inject(deps)
@observer
export class CheckoutActions extends Component<CheckoutActionsProps> {
  render() {
    const { handleCheckout, eula, rightsholders, className, showVat = true } = this.props;
    const { checkout, user, basket } = this.props.model;

    let buttonText = 'Checkout';
    let total: number | string = checkout.total;
    let disabled = true;
    let canCheckout = false;
    if (!user.user) {
      buttonText = 'Sign in to checkout';
      total = basket.total;
      // The user isn't signed in, button will pop up a sign in modal, don't disable
      disabled = false;
    } else if (checkout.orderState === ORDER_STATE.LOADING) {
      buttonText = 'Loading...';
    } else if (checkout.orderState === ORDER_STATE.ERROR) {
      buttonText = 'An error occurred';
    } else if (!eula || !rightsholders) {
      // One of the terms checkboxes isn't ticked, button will scroll checkboxes in view when clicked, don't disable
      disabled = false;
    } else if (checkout.orderState === ORDER_STATE.READY) {
      // Order is ready, don't disable
      disabled = false;
      canCheckout = true;
    }

    return (
      <div className={className}>
        <div className="totalText">
          <span className={styles.totalText}>Total to pay</span>
          <span className={styles.totalText}>{formatCurrency(total, checkout.currency)}</span>
          {!!(showVat && checkout.vatRate) && (
            <p className={styles.smallText}>(inc. VAT at {formatVAT(checkout.vatRate)})</p>
          )}
        </div>
        <ButtonPill
          disabled={disabled}
          primary={canCheckout}
          tertiary={!canCheckout}
          onClick={handleCheckout}
          className="checkoutButton"
          type="submit"
        >
          {buttonText}
        </ButtonPill>
      </div>
    );
  }
}
